import React from "react";
// Removed unused useState, useEffect
// Keep findObjectByKeyValue if still needed, otherwise remove
// import { findObjectByKeyValue } from '../utils.js';

// ** UPDATED: Directly use the processed teamPlayers prop **
function ListPlayers({ formationInfo, teamPlayers }) {

    // Derive FIRST TEAM and SUBS arrays
    let firstTeamPlayers = teamPlayers.filter(p => p.isStartingXI);
    let substitutionPlayers = teamPlayers.filter(p => p.isSubstitute);

    // Helper to obtain a numeric sort key based on formation slot's sortOrder
    const getSortKey = (player) => {
        if (!formationInfo || !formationInfo.positions) return 999;

        // Starting XI – use the assigned formationPlaceId
        if (player.isStartingXI && player.formationPlaceId != null) {
            const slot = formationInfo.positions.find(pos => pos.id === player.formationPlaceId);
            return slot ? Number(slot.sortOrder || 999) : 999;
        }

        // Substitutes – attempt to map their subPosition or general role to a slot
        const positionLabel = player.subPosition || player.role?.name;
        if (positionLabel) {
            const slot = formationInfo.positions.find(pos => pos.position === positionLabel);
            if (slot) return Number(slot.sortOrder || 999);
        }

        return 999;
    };

    // Sort in place (GK top, FW bottom because sortOrder ascending)
    firstTeamPlayers = [...firstTeamPlayers].sort((a, b) => getSortKey(a) - getSortKey(b));
    substitutionPlayers = [...substitutionPlayers].sort((a, b) => getSortKey(a) - getSortKey(b));

    // Optional: Bench players (not in XI or subs)
    // const benchPlayers = teamPlayers.filter(p => !p.isStartingXI && !p.isSubstitute);

    const playerGroups = [
        { title: "FIRST TEAM", players: firstTeamPlayers },
        { title: "SUBSTITUTES", players: substitutionPlayers },
        // { title: "BENCH", players: benchPlayers }, // Uncomment if needed
    ];

    // ** UPDATED: Simplified rendering function **
    function renderPlayerList(players) {
        if (!players || players.length === 0) {
            return null; // Return null instead of empty string for clarity
        }

        return players.map(function (player) {
            // Determine the position to display
            let displayPosition = null; // Initialize to null

            if (player.isStartingXI && player.formationPlaceId && formationInfo?.positions) {
                // If assigned to XI, find the specific position label
                const slotInfo = formationInfo.positions.find(pos => pos.id === player.formationPlaceId);
                if (slotInfo) {
                    displayPosition = slotInfo.position || slotInfo.title || 'XI'; // Use position string or title
                }
            } else if (player.isSubstitute && player.subPosition) {
                // If assigned as sub, use that position
                // Optional: Remove "SUB - " prefix if present
                displayPosition = player.subPosition.startsWith('SUB - ') ? player.subPosition.substring(6) : player.subPosition;
            }

            // ** NEW: If still null after checks, use the player's general role name as a fallback **
            if (displayPosition === null) {
                displayPosition = player.role?.name || 'N/A'; // Fallback to role name, then N/A
            }

            // ** UPDATED: Use player._id or player.wyId as the key **
            const key = player._id || player.wyId || `player-${player.name}`; // Prioritize _id, then wyId, fallback to name (less ideal)

            return (
                <li key={key}>
                    <span className="pos">
                        {displayPosition}
                    </span>
                    {/* Display number */}
                    {player.number && <span className="number">{player.number}</span>}
                    <span className="name">
                        {player.name}
                    </span>
                </li>
            );
        });
    }

    return (
        <div className="list-block">
            {playerGroups.map((group, index) => (
                // Only render group if it has players
                group.players.length > 0 && (
                    <div key={group.title || index} className="list-container">
                        <h4>
                            {group.title}
                        </h4>
                        <ul className="players-list">
                            {renderPlayerList(group.players)}
                        </ul>
                    </div>
                )
            ))}
        </div>
    );
}

export { ListPlayers };
